import React from 'react'
import { useMutation } from 'react-query'
import { toast } from 'react-toastify'
import posthog from 'posthog-js'
import { rememberPaymentFlow } from 'utilities/analytics/paymentFlow'
import { addOnlinePayForOtherInLoan, postGatewayPaymentOneItemInstallment } from 'services/easyPay'

export default function useSetPay(data?: any) {
    const { mutate } = useMutation({
        mutationFn: (payload: any) => {
            return postGatewayPaymentOneItemInstallment(payload)
        },
        onSuccess: (result, variables) => {
            localStorage.setItem(
                'toBePaidTransactions',
                JSON.stringify({
                    // `type` is what the gateway callback reports as
                    // `flow_type` on payment_succeeded / payment_failed, so it
                    // has to be the same string this screen tags the redirect
                    // with. It used to say «pay-for-other», one character away
                    // from the unrelated «pay-for-others» flow the callback
                    // branches on, which split one funnel across two names.
                    //
                    // The callback has no branch for this value and falls
                    // through to /funds — which is the right landing for a
                    // repayment — so the rename is behaviour-preserving.
                    type: 'loan_installment',
                    data: data ? data : [],
                    //@ts-ignore
                    // pk: result.cashin.transaction.pk,
                    //@ts-ignore
                    // gateway: 0,
                })
            )
            const items: any[] = variables?.paymentItems ?? []
            posthog.capture('payment_gateway_redirect', { flow_type: 'loan_installment' })
            rememberPaymentFlow({
                flow_type: 'loan_installment',
                amount: items.reduce(
                    (sum, item) =>
                        sum + Number(item?.itemAmount ?? 0) +
                        Number(item?.commission ?? 0),
                    0
                ),
                gateway: variables?.gateway?.uniqueCode ?? null,
                box_id: items[0]?.box_id ?? null,
                box_type: 'mnp',
            })
            //@ts-ignore
            window.location.replace(result?.payment_link)
            toast.success('در حال انتقال به صفحه کارت به کارت')
        },
        onError: () => {
            posthog.capture('payment_initiate_failed', { flow_type: 'loan_installment' })
            toast.error('مشکلی پیش آمده!')
        },
    })
    return { mutate }
}
